import { APIConstants, CREATE_SESSION_ACTION_TYPE } from '../../constants';
import axios from 'axios';

export const dropSsoSession = async (
  config: (key: string) => string | undefined
): Promise<void> => {
  try {
    const dropSsoSessionUrl = `${config(APIConstants.CONFIG.SESSION_INIT_URL)}`;
    const options = {
      method: 'POST',
      url: dropSsoSessionUrl,
      params: {
        actionType: CREATE_SESSION_ACTION_TYPE.DROP,
      },
    };
    await axios(options);
  } catch (error) {
    throw error;
  }
};
